import Header from './Header/Header'
import Footer from './Footer/Footer'
import Secure from './Secure/Secure'
import ScrollToTop from './ScrollToTop/ScrollToTop'
import { AuthLevelRequired } from '../../../types/Auth'

type Props = {
  children: React.ReactNode
  className?: string
  authLevelRequired?: AuthLevelRequired
  hideNavigation?: boolean
  noFooter?: boolean
  disableDynamicHeightHeader?: boolean
  // smallHeader?: boolean
  logo?: string
  wideHeader?: boolean
}

const Layout: React.FC<Props> = ({
  children,
  className,
  hideNavigation,
  authLevelRequired = [],
  noFooter = false,
  disableDynamicHeightHeader = false,
  // smallHeader = false,
  logo,
  wideHeader = false,
}) => {
  return (
    <div className={`bg-background ${className}`}>
      <Secure authLevelRequired={authLevelRequired}>
        <ScrollToTop />
        <Header wide={wideHeader} hideNavigation={hideNavigation} disableDynamicHeight={disableDynamicHeightHeader} customLogo={logo} />
        <div className={`relative overflow-x-hidden min-h-screen pt-16`}>{children}</div>
        {!noFooter && <Footer />}
      </Secure>
    </div>
  )
}

export default Layout
